import React, { Component } from "react";
import { connect } from "react-redux";
import { MainContainerTheme } from "Themes/Metrics";

class PageNotFoundContainer extends Component {
  state = {};
  render() {
    return (
      <MainContainerTheme>
        <h1>404 Page Not Found</h1>
        <h2>You didn't see anything...right!</h2>
      </MainContainerTheme>
    );
  }
}

const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = dispatch => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PageNotFoundContainer);
